import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/patient-transaction";

export const initPrepaidCardTransaction = (obj) =>
  axios.post(API_PATH + "/init-prepaid-card-transaction", obj);

export const getTotalUsedDeposit = (patientId) =>
  axios.get(API_PATH + "/get-total-used-deposit/" + patientId);
export const initAdvanceMoneyTransaction = (obj) =>
  axios.post(API_PATH + "/init-advance-money-transaction", obj);
export const pagingPatientTransaction = (obj) =>
  axios.post(API_PATH + "/search-by-page", obj);

export const initPrepaidCardFromParentTransaction = (obj) =>
  axios.post(API_PATH + "/init-prepaid-card-transaction-from-parent", obj);

export const initFromPointTransaction = (obj) =>
  axios.post(API_PATH + "/init-transaction-from-point", obj);
